import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/lib/api';
import { STALE_TIME } from '@/app/query-client';

interface Versao {
  versao: string;
  commit: string;
  buildEm: string;
}

/**
 * Versão do build no rodapé (.spec/001, seção 8).
 *
 * Serve ao suporte: "está na 0.4.2?" é uma pergunta respondível pelo usuário
 * em dois segundos, e evita depurar um problema já corrigido numa versão que
 * o navegador dele ainda não baixou.
 */
export function Versao(): React.ReactElement | null {
  const { data } = useQuery({
    queryKey: ['meta', 'version'],
    queryFn: () => api.get<Versao>('/api/v1/meta/version'),
    staleTime: STALE_TIME.cadastro,
  });

  if (!data) return null;

  return (
    <p className="cota text-grafite-500" title={`commit ${data.commit}`}>
      v{data.versao}
    </p>
  );
}
